import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useControlEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { getItem, updateItem } = useLambda()
  const { addAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const control = ref({})
  const isSubmitting = ref(false)
  const originalData = ref(null)
  const query = {
    _id: oid(route.value.params.id),
    client_id: oid(userData.client.$oid),
    deleted: { $ne: true },
  }
  const collection = 'control'

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })

      if (!item) {
        showErrorMessage(i18n.t('message.you_are_not_authorized'))
        router.push({ name: 'organization-control-list' })
        return
      }

      // Inicializar history si no existe (documentos legacy)
      if (!item.history) {
        item.history = []
      }

      item.behaviours = item.behaviours?.map(e => String(e)) || []
      item.responsible_id = item.responsible_id ? String(item.responsible_id) : null
      control.value = item
      originalData.value = JSON.parse(JSON.stringify(item))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.control_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async (data, redirect = true) => {
    if (!hasPermission('controls', 'edit')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const updateQuery = data._id ? { _id: oid(data._id) } : query
      const payload = {
        name: data.name,
        // responsible: data.responsible || '',
        responsible_id: data.responsible_id ? oid(data.responsible_id) : null,
        behaviours: data.behaviours?.map(e => oid(e)) || []
      }

      const action = { $set: payload }

      await updateItem({ collection, query: updateQuery, action })

      // Add audit log entry
      await addAuditEntry({
        collection,
        documentId: updateQuery._id,
        originalData: originalData.value,
        updatedData: {
          name: payload.name,
          responsible: payload.responsible,
          responsible_id: payload.responsible_id,
          behaviours: payload.behaviours,
        },
      })

      showSuccessMessage(i18n.t('message.control_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.control_update_error'))
    } finally {
      if (redirect) router.push({ name: 'organization-control-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    control,
    isSubmitting,
  }
}
